import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * DrawerLeft icon
 *
 * @file DrawerLeft.jsx
 * @author Sam George
 */
const DrawerLeft = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M20.5,1 C21.8807119,1 23,2.11928813 23,3.5 L23,20.5 C23,21.8807119
      21.8807119,23 20.5,23 L3.5,23 C2.11928813,23 1,21.8807119 1,20.5 L1,3.5
      C1,2.11928813 2.11928813,1 3.5,1 L20.5,1 Z M9,3 L3.83333333,3 C3.37309604,3
      3,3.22385763 3,3.5 L3,20.5 C3,20.7761424 3.37309604,21 3.83333333,21 L9,21
      L9,3 Z M20.5833333,3 L11,3 L11,21 L20.5833333,21 C20.813452,21 21,20.7761424
      21,20.5 L21,3.5 C21,3.22385763 20.813452,3 20.5833333,3 Z M6.5,15
      C6.77614237,15 7,15.2238576 7,15.5 L7,16.5 C7,16.7761424 6.77614237,17
      6.5,17 L5.5,17 C5.22385763,17 5,16.7761424 5,16.5 L5,15.5 C5,15.2238576
      5.22385763,15 5.5,15 L6.5,15 Z M6.5,11 C6.77614237,11 7,11.2238576
      7,11.5 L7,12.5 C7,12.7761424 6.77614237,13 6.5,13 L5.5,13 C5.22385763,13
      5,12.7761424 5,12.5 L5,11.5 C5,11.2238576 5.22385763,11 5.5,11 L6.5,11
      Z M6.5,7 C6.77614237,7 7,7.22385763 7,7.5 L7,8.5 C7,8.77614237 6.77614237,9
      6.5,9 L5.5,9 C5.22385763,9 5,8.77614237 5,8.5 L5,7.5 C5,7.22385763
      5.22385763,7 5.5,7 L6.5,7 Z"
    />
  </SvgIcon>
);

export default DrawerLeft;
